import { Instant } from 'js-joda';
import { Typography } from 'omakase';
import { padStart, toString } from 'es-toolkit/compat';
import BaseComponent from '@tock/shared/components/BaseComponent';

interface Props {
  lockedUntilMs?: number;
  onLockExpiration(): void;
}

interface State {
  time: number;
  remainingMs?: number;
}
class LockTimer extends BaseComponent<Props, State> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  interval: any;

  constructor(props: Props) {
    super(props);

    this.state = {
      time: Date.now(),
    };
  }

  componentDidMount() {
    this.play();
  }

  componentWillUnmount() {
    this.pause();
  }

  pause() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }

  play() {
    if (!this.interval) {
      this.update();
      this.interval = setInterval(this.update, 1000);
    }
  }

  update() {
    const { lockedUntilMs } = this.props;
    const remainingMs = !lockedUntilMs ? 0 : lockedUntilMs - Instant.now().toEpochMilli();

    this.setState({
      time: Date.now(),
      remainingMs,
    });

    if (remainingMs < 0) {
      this.props.onLockExpiration();
    }
  }

  render() {
    const { remainingMs } = this.state;
    const { lockedUntilMs } = this.props;
    const hideTimer = !lockedUntilMs || !remainingMs || remainingMs < 0;

    if (hideTimer) {
      return null;
    }

    return (
      <div data-testid="locktimer" className="LockTimer">
        <div className="LockTimer-container">
          <Typography color="inherit" component="span" variant="body02">
            {
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              Math.floor(remainingMs! / 60000)
            }
            :
            {padStart(
              toString(
                Math.floor(
                  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                  (remainingMs! / 1000) % 60
                )
              ),
              2,
              '0'
            )}
          </Typography>
        </div>
      </div>
    );
  }
}

export default LockTimer;
